import { getNewspageId, getProjectId, getPublicationElements } from './utility'
import { setButtonLoadingState, setInputState } from './input'

import ky, { HTTPError } from 'ky'
import { WebStorage } from './storage'

export function initializeFeedbackTextarea() {
    const publicationElements = getPublicationElements()
    for (const publicationElement of publicationElements) {
        const publicationId = publicationElement.dataset.publicationId as string

        const feedbackTextareas = publicationElement.getElementsByClassName('feedback-textarea')

        if (feedbackTextareas && feedbackTextareas.length > 0) {
            const feedbackTextarea = feedbackTextareas[0] as HTMLTextAreaElement
            feedbackTextarea.addEventListener(
                'input',
                function (event: Event) {
                    const targetElement = event.target as HTMLInputElement
                    autoExpand(targetElement)

                    const comment = targetElement.value
                    const feedbackSendButtons =
                        targetElement.parentElement?.getElementsByClassName('feedback-send-button')

                    if (feedbackSendButtons && feedbackSendButtons.length > 0) {
                        const feedbackSendButton = feedbackSendButtons[0] as HTMLElement
                        feedbackSendButton.style.display = !comment || comment.trim().length === 0 ? 'none' : 'block'
                    }
                },
                false,
            )

            const feedbackCommentElement = publicationElement.getElementsByClassName(
                'post-content-feedback-comment',
            )[0] as HTMLElement
            const sessionStorageKey = 'noticeable:publications:' + publicationId + ':comment'

            let existingContent = window.sessionStorage.getItem(sessionStorageKey) as any
            if (existingContent) {
                existingContent = JSON.parse(existingContent)

                if (existingContent.sendTime && existingContent['sendTime'] > 0) {
                    feedbackCommentElement.style.display = 'none'
                    const feedbackSentElement = publicationElement.getElementsByClassName(
                        'post-content-feedback-sent',
                    )[0] as HTMLElement
                    feedbackSentElement.style.display = 'block'
                } else if (existingContent['value']) {
                    feedbackTextarea.value = existingContent['value']
                    feedbackCommentElement.style.display = 'block'
                    const btnContinueElement = publicationElement.getElementsByClassName(
                        'btn-continue',
                    )[0] as HTMLElement
                    btnContinueElement.style.display = 'block'
                }
            } else {
                feedbackCommentElement.style.display = 'block'
            }
        }
    }
}

function autoExpand(field) {
    field.style.height = 'inherit'

    const computed = window.getComputedStyle(field)
    const height =
        parseInt(computed.getPropertyValue('border-top-width'), 10) +
        field.scrollHeight +
        parseInt(computed.getPropertyValue('border-bottom-width'), 10)

    field.style.height = height + 'px'
}

export function feedbackContinue(button, publicationId: string) {
    button.parentElement.style.display = 'none'

    const container = button.parentElement.parentElement
    const feedbackUserDetails = container.getElementsByClassName('post-content-feedback-user-details')[0]
    feedbackUserDetails.style.display = 'block'

    const sessionStorageKey = 'noticeable:publications:' + publicationId + ':comment'
    let existingContent: any = window.sessionStorage.getItem(sessionStorageKey)

    let userTraits: any = window.sessionStorage.getItem('noticeable:traits')
    userTraits = !userTraits ? {} : JSON.parse(userTraits)

    if ((userTraits.email && userTraits.name) || window.noticeable.commentIdentityCollection === 'ignore') {
        feedbackSend(publicationId, true)
    } else {
        const emailInput = container.getElementsByClassName('feedback-email')[0]
        const nameInput = container.getElementsByClassName('feedback-displayname')[0]

        existingContent = !existingContent ? {} : JSON.parse(existingContent)

        if (existingContent.email) {
            emailInput.required = window.noticeable.commentIdentityCollection === 'required'
            emailInput.value = existingContent.email
        } else if (userTraits.email) {
            emailInput.required = window.noticeable.commentIdentityCollection === 'required'
            emailInput.value = userTraits.email
        }

        if (existingContent.displayName) {
            nameInput.required = window.noticeable.commentIdentityCollection === 'required'
            nameInput.value = existingContent.displayName
        } else if (userTraits.displayName) {
            nameInput.required = window.noticeable.commentIdentityCollection === 'required'
            nameInput.value = userTraits.displayName
        }
    }
}

export function feedbackInput(input, publicationId) {
    const continueButton = input.parentElement.getElementsByClassName('btn-continue')[0]
    const sessionStorageKey = 'noticeable:publications:' + publicationId + ':comment'

    if (!input.value || input.value.trim() === '') {
        continueButton.style.display = 'none'
        window.sessionStorage.removeItem(sessionStorageKey)
        return
    }

    let existingContent: any = window.sessionStorage.getItem(sessionStorageKey)
    if (existingContent) {
        existingContent = JSON.parse(existingContent)
    } else {
        existingContent = {}
    }

    existingContent['value'] = input.value

    continueButton.style.display = 'block'
    window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(existingContent))
}

export async function feedbackSend(publicationId: string, skipEmailNameCollection = false) {
    const postContentFeedbackElement = document.querySelector('.post-content-feedback') as HTMLElement
    const sessionStorageKey = 'noticeable:publications:' + publicationId + ':comment'

    let existingContent: any = window.sessionStorage.getItem(sessionStorageKey)
    if (existingContent) {
        existingContent = JSON.parse(existingContent)
    }

    const displayNameInput = postContentFeedbackElement.getElementsByClassName(
        'feedback-displayname',
    )[0] as HTMLInputElement
    const emailInput = postContentFeedbackElement.getElementsByClassName('feedback-email')[0] as HTMLInputElement

    if (!skipEmailNameCollection) {
        if (!emailInput.checkValidity() || !displayNameInput.checkValidity()) {
            return
        }

        if (emailInput.value && emailInput.value.trim() !== '') {
            existingContent['email'] = emailInput.value
        }

        if (displayNameInput.value && displayNameInput.value.trim() !== '') {
            existingContent['displayName'] = displayNameInput.value
        }
    }

    window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(existingContent))

    const postContentFeedbackCommentElement = postContentFeedbackElement.getElementsByClassName(
        'post-content-feedback-comment',
    )[0] as HTMLElement
    const postContentFeedbackErrorElement = postContentFeedbackElement.getElementsByClassName(
        'post-content-feedback-error',
    )[0] as HTMLElement
    const postContentFeedbackUserDetailsElement = postContentFeedbackElement.getElementsByClassName(
        'post-content-feedback-user-details',
    )[0] as HTMLElement
    const postContentFeedbackSentElement = postContentFeedbackElement.getElementsByClassName(
        'post-content-feedback-sent',
    )[0] as HTMLElement

    postContentFeedbackErrorElement.style.display = 'none'
    postContentFeedbackSentElement.style.display = 'none'

    postContentFeedbackCommentElement.style.display = skipEmailNameCollection ? 'block' : 'none'
    postContentFeedbackUserDetailsElement.style.display = skipEmailNameCollection ? 'none' : 'block'

    const buttonElement = (
        skipEmailNameCollection ? postContentFeedbackCommentElement : postContentFeedbackUserDetailsElement
    ).getElementsByTagName('button')[0] as HTMLButtonElement

    const projectId = getProjectId()
    const userId = WebStorage.getUserId(projectId)
    const userTraits = WebStorage.getUserTraits(projectId)

    setButtonLoadingState(buttonElement, true)
    setInputState(
        skipEmailNameCollection ? postContentFeedbackCommentElement : postContentFeedbackUserDetailsElement,
        'input',
        true,
    )
    setInputState(
        skipEmailNameCollection ? postContentFeedbackCommentElement : postContentFeedbackUserDetailsElement,
        'textarea',
        true,
    )
    try {
        const response = await ky.post(window.noticeable.pipelineBaseUrl + '/c', {
            headers: {
                'content-type': 'application/json',
            },
            json: {
                c: existingContent['value'],
                o: 'n',
                i: getNewspageId(),
                p: projectId,
                q: publicationId,
                r: window.location.href,
                s: WebStorage.getUserSsoToken(projectId),
                t: {
                    a: userTraits.avatarUrl,
                    d: userTraits.displayName ?? existingContent['displayName'],
                    e: userTraits.email ?? existingContent['email'],
                    f: userTraits.firstName,
                    i: userId,
                    l: userTraits.lastName,
                },
            },
        })

        if (response.ok && (response.status === 200 || response.status === 204)) {
            postContentFeedbackCommentElement.style.display = 'none'
            postContentFeedbackUserDetailsElement.style.display = 'none'
            setButtonLoadingState(buttonElement, false)
            setInputState(
                skipEmailNameCollection ? postContentFeedbackCommentElement : postContentFeedbackUserDetailsElement,
                'input',
                false,
            )
            setInputState(
                skipEmailNameCollection ? postContentFeedbackCommentElement : postContentFeedbackUserDetailsElement,
                'textarea',
                false,
            )
            postContentFeedbackErrorElement.style.display = 'none'
            postContentFeedbackSentElement.style.display = 'block'

            existingContent['sendTime'] = Date.now()

            window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(existingContent))

            window.noticeable.parentWindow?.dispatchEvent('widget:publication:comment:created', {
                comment: existingContent['value'],
                projectId: projectId,
                publicationId: publicationId,
                userTraits: {
                    /** @deprecated: use avatarUrl instead */
                    avatar: userTraits.avatarUrl,
                    avatarUrl: userTraits.avatarUrl,
                    displayName: userTraits.displayName ?? existingContent['displayName'],
                    email: userTraits.email ?? existingContent['email'],
                    fistName: userTraits.firstName,
                    /** @deprecated: use displayName instead */
                    fullName: existingContent['displayName'] ?? userTraits.displayName,
                    id: userId,
                    lastName: userTraits.lastName,
                },
            })

            postContentFeedbackSentElement.style.display = 'block'
        } else {
            const message = ((await response.json()) as any).message
            setButtonLoadingState(buttonElement, false)
            setInputState(
                skipEmailNameCollection ? postContentFeedbackCommentElement : postContentFeedbackUserDetailsElement,
                'input',
                false,
            )
            setInputState(
                skipEmailNameCollection ? postContentFeedbackCommentElement : postContentFeedbackUserDetailsElement,
                'textarea',
                false,
            )
            postContentFeedbackCommentElement.style.display = 'block'
            postContentFeedbackErrorElement.style.display = 'block'

            postContentFeedbackErrorElement.innerText = postContentFeedbackErrorElement.innerText.replaceAll(
                '{error_message}',
                message,
            )
            postContentFeedbackSentElement.style.display = 'none'
            postContentFeedbackUserDetailsElement.style.display = 'none'
        }
    } catch (error: any) {
        setButtonLoadingState(buttonElement, false)
        setInputState(
            skipEmailNameCollection ? postContentFeedbackCommentElement : postContentFeedbackUserDetailsElement,
            'input',
            false,
        )
        setInputState(
            skipEmailNameCollection ? postContentFeedbackCommentElement : postContentFeedbackUserDetailsElement,
            'textarea',
            false,
        )
        postContentFeedbackCommentElement.style.display = 'block'
        postContentFeedbackErrorElement.style.display = 'block'
        postContentFeedbackErrorElement.innerText = postContentFeedbackErrorElement.innerText.replaceAll(
            '{error_message}',
            await toString(error),
        )
        postContentFeedbackSentElement.style.display = 'none'
        postContentFeedbackUserDetailsElement.style.display = 'none'
    }
}

async function toString(error): Promise<string> {
    if (error instanceof HTTPError) {
        // ky consumes and parses the error response body into error.data, response.json() no longer works
        const data = error.data
        if (data && typeof data === 'object' && typeof data['message'] === 'string') {
            return data['message']
        }
        return error.toString()
    }

    return 'You made too many requests. Please retry in a few minutes.'
}
